import React from 'react';
import {
    Row, Col, Typography, Divider, Image, Card, Descriptions, Tag, Carousel, Button
} from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';

const { Title, Text, Paragraph } = Typography;

const CDetalleVistaArticulo = () => {
    const { state } = useLocation();
    const navigate = useNavigate();
    const articulo = state?.articulo;

    if (!articulo || !articulo.articulo_empresa) {
        return (
            <div style={{ padding: '2rem' }}>
                <Title level={4} type="danger">Error</Title>
                <Text>No se pudo cargar la información del artículo.</Text>
            </div>
        );
    }

    const { articulo_empresa: aem, datos_sucursal: asu } = articulo;
    const imagenes = [aem.aem_imagen, aem.aem_imagen2, aem.aem_imagen3].filter(Boolean);

    return (
        <div style={{ padding: '2rem' }}>
            <Button type="default" onClick={() => navigate(-1)} style={{ marginBottom: '1rem' }}>
                ← Volver a la lista
            </Button>

            <Row gutter={[32, 32]}>
                {/* COLUMNA IZQUIERDA - IMÁGENES */}
                <Col xs={24} md={12}>
                    <Card>
                        <Carousel autoplay dotPosition="bottom">
                            {imagenes.map((img, idx) => (
                                <div
                                    key={idx}
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        height: 550
                                    }}
                                >
                                    <Image
                                        src={img}
                                        alt={`Imagen ${idx + 1}`}
                                        style={{ maxHeight: 500, maxWidth: '100%', objectFit: 'contain' }}
                                        preview
                                    />
                                </div>
                            ))}
                        </Carousel>
                    </Card>
                </Col>


                {/* COLUMNA DERECHA - INFO PRINCIPAL */}
                <Col xs={24} md={12}>
                    <Title level={3} style={{ marginBottom: 0 }}>{aem.aem_nombre}</Title>
                    <Text type="secondary">SKU: {aem.aem_sku}</Text>

                    <div style={{ margin: '1.2rem 0' }}>
                        <Text strong style={{ fontSize: 26, color: '#52c41a' }}>
                            ${asu?.asu_precio_con_descuento?.toLocaleString()}
                        </Text>
                        {asu?.asu_precioventa && (
                            <div>
                                <Text delete style={{ marginRight: 8, fontSize: 14, color: '#999' }}>
                                    ${asu.asu_precioventa.toLocaleString()}
                                </Text>
                                <Text type="success">-{asu.asu_porc_descuento}% OFF</Text>
                            </div>
                        )}
                    </div>

                    {asu?.asu_stock && (
                        <Text style={{ display: 'block', marginBottom: 12 }}>
                            <b>Stock disponible:</b> {asu.asu_stock} unidades
                        </Text>
                    )}

                    <Divider />

                    <Paragraph strong>Descripción corta</Paragraph>
                    <Text>{aem.aem_descripcion_corta}</Text>

                    <Divider />

                    <Paragraph strong>Descripción larga</Paragraph>
                    <Text>{aem.aem_descripcion_larga}</Text>

                    <Divider />

                    <Paragraph strong>Marca</Paragraph>
                    <Text>{aem.aem_marca}</Text>

                    <Divider />

                    <Paragraph strong>Etiquetas</Paragraph>
                    <div>
                        {aem.aem_tags
                            ? aem.aem_tags.split(',').map((tag, i) => <Tag key={i}>{tag.trim()}</Tag>)
                            : <Text type="secondary">Sin tags</Text>}
                    </div>
                </Col>
            </Row>

            {/* BLOQUE DE DATOS GENERALES Y SUCURSAL */}
            <Row gutter={[32, 32]} style={{ marginTop: '2rem' }}>
                <Col xs={24}>
                    <Paragraph strong>Datos generales del artículo</Paragraph>
                    <Descriptions bordered column={2} size="small">
                        <Descriptions.Item label="Tipo ID">{aem.aem_tipo_id}</Descriptions.Item>
                        <Descriptions.Item label="Categoría ID">{aem.aem_categoria_id}</Descriptions.Item>
                        <Descriptions.Item label="Creado">{new Date(aem.aem_fecha_creacion).toLocaleString()}</Descriptions.Item>
                        <Descriptions.Item label="Modificado">{new Date(aem.aem_fecha_modificacion).toLocaleString()}</Descriptions.Item>
                    </Descriptions>
                </Col>

                {asu && (
                    <Col xs={24}>
                        <Divider />
                        <Paragraph strong>Datos específicos de sucursal</Paragraph>
                        <Descriptions bordered column={2} size="small">
                            <Descriptions.Item label="Precio sin IVA">${asu.asu_precio_siniva}</Descriptions.Item>
                            <Descriptions.Item label="Precio costo">${asu.asu_preciocosto}</Descriptions.Item>
                            <Descriptions.Item label="Stock mínimo">{asu.asu_stock_minimo}</Descriptions.Item>
                            <Descriptions.Item label="Ubicación interna">{asu.asu_ubicacion_interna}</Descriptions.Item>
                            <Descriptions.Item label="Orden de relevancia">{asu.asu_orden_relevancia ?? '—'}</Descriptions.Item>
                            <Descriptions.Item label="Fecha alta">{asu.asu_fechaalta}</Descriptions.Item>
                            <Descriptions.Item label="Último cambio">{asu.asu_fechaultimocambio}</Descriptions.Item>
                            <Descriptions.Item label="Descuento desde">{asu.asu_fecha_d_descuento}</Descriptions.Item>
                            <Descriptions.Item label="Descuento hasta">{asu.asu_fecha_h_descuento}</Descriptions.Item>
                        </Descriptions>
                    </Col>
                )}
            </Row>
        </div>
    );
};

export default CDetalleVistaArticulo;
